module.exports = __webpack_public_path__ + "img/gift.daee6675.png";